import React, { useState, useEffect } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { getSubscription } from "../../FindagramAdmin/BaseUrl/SubscriptionApi";

//import images
import avatar1 from "../../assets/images/users/avatar-1.jpg";

const ProfileDropdown = () => {
    //Dropdown Toggle
    const [isProfileDropdown, setIsProfileDropdown] = useState(false);
    const [subscriptionData, setSubscriptionData] = useState(null);
    const [subscriptionLoading, setSubscriptionLoading] = useState(true);
    
    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };

    // Fetch subscription data from API
    useEffect(() => {
        const fetchSubscriptionData = async () => {
            try {
                const response = await getSubscription();
                setSubscriptionData(response?.responseData);
            } catch (error) {
                console.error("Failed to fetch subscription:", error);
                setSubscriptionData(null);
            } finally {
                setSubscriptionLoading(false);
            }
        };

        fetchSubscriptionData();
    }, []);
    return (
        <React.Fragment>
            <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown} className="ms-sm-3 header-item topbar-user">
                <DropdownToggle tag="button" type="button" className="btn shadow-none">
                    <span className="d-flex align-items-center">
                        <i className="mdi mdi-account-circle text-muted fs-20 align-middle "></i>

                        <span className="text-start ms-xl-2">
                            <span className="d-none d-xl-inline-block fw-medium user-name-text">
                                {JSON.parse(localStorage.getItem("authUser"))?.firstName} {JSON.parse(localStorage.getItem("authUser"))?.lastName}
                            </span>

                            {/* <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">Founder</span> */}
                        </span>
                    </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">

                    {/* <h6 className="dropdown-header">Welcome Anna!</h6> */}
                    <DropdownItem href="/profile-setup"><i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
                        <span className="align-middle">Profile</span></DropdownItem>

{!subscriptionLoading && (!subscriptionData?.subscriptionType || subscriptionData?.subscriptionType === "free") && (
  <DropdownItem href="/subscription-detail">
    <i className="mdi mdi-credit-card-outline text-muted fs-16 align-middle me-1"></i>
    <span className="align-middle">Add Subscription</span>
  </DropdownItem>
)}

{!subscriptionLoading && subscriptionData?.subscriptionType && subscriptionData?.subscriptionType !== "free" && (
  <DropdownItem href="/subscription-detail">
    <i className="mdi mdi-credit-card-outline text-muted fs-16 align-middle me-1"></i>
    <span className="align-middle">Subscription Details</span>
  </DropdownItem>
)}




                    <DropdownItem href="/logout"><i
                        className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> <span
                            className="align-middle" data-key="t-logout">Logout</span></DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default ProfileDropdown;